// extracted by mini-css-extract-plugin
export default {"main_container":"ModifySuperUser_main_container__NlXoT","user_details_container":"ModifySuperUser_user_details_container__JOBho"};